window.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('header')
	const mobileMenu = document.querySelector('header .nav-buttons-container')
	const hamburger = document.querySelector('header .hamburger')
	if (!hamburger || !mobileMenu) return

	let previousScrollTop = 0
	let menuJustToggled = false

	const setMenuOpen = (open) => {
		hamburger.classList.toggle('open', open)
		mobileMenu.classList.toggle('open', open)
		hamburger.setAttribute('aria-expanded', open)
		hamburger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu')
	}

	window.addEventListener('scroll', () => {
		const currentScrollTop = window.scrollY
		if (currentScrollTop > previousScrollTop && currentScrollTop > 100) {
			header.classList.add('nav-hidden')
			if (!menuJustToggled) setMenuOpen(false)
		} else if (currentScrollTop < previousScrollTop) {
			header.classList.remove('nav-hidden')
		}
		previousScrollTop = currentScrollTop
	})

	hamburger.addEventListener('click', () => {
		menuJustToggled = true
		const willOpen = !mobileMenu.classList.contains('open')
		setMenuOpen(willOpen)
		if (willOpen) {
			const firstLink = mobileMenu.querySelector('a[href]')
			if (firstLink) firstLink.focus()
		}
		setTimeout(() => { menuJustToggled = false }, 100)
	})

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && mobileMenu.classList.contains('open')) {
			setMenuOpen(false)
			hamburger.focus()
		}
	})
})
